import { render } from "./VentsMainList.vue?vue&type=template&id=2e6e7f47"
import script from "./VentsMainList.vue?vue&type=script&lang=js"
export * from "./VentsMainList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__